export default __webpack_public_path__ + "static/media/alcatraz-paper.803e4230.jpg";